import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Checkbox, Heading, Paragraph, ValidationMessage } from '@digdir/designsystemet-react';

import { OppvarmingFormData } from '../../../types';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { Oljekamin } from './oljekamin';
import { Oljekjel } from './kjel';

export const Olje = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.olje' });
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const oljeSelected = watch('olje.selected');

  const oppvarmingSelectionError = formState.errors?.olje?.selected?.message;
  const oljeSelectionError = formState.errors?.olje?.value?.kamin?.selected?.message;

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!oppvarmingSelectionError}
        label={t('label')}
        {...register('olje.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {oljeSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('heading')}
            </Heading>
            <Paragraph>{t('description')}</Paragraph>
          </LeftBorderedContent>

          <Oljekamin />
          <Oljekjel />
          {oljeSelectionError && (
            <LeftBorderedContent>
              <ValidationMessage>{oljeSelectionError}</ValidationMessage>
            </LeftBorderedContent>
          )}
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
